import React from "react"
import HeadingL from "../../components/shared/HeadingL"
import Layout from "../../components/sutea/Layout"
import SEO from "../../components/Seo"
import { PAGE } from "../../constants"
import AssessmentPage from "../../components/sutea/SupportProgramPage"

const support_program = () => (
  <Layout>
    <SEO title={PAGE.title.support_program} siteTitle="sutea" />
    <HeadingL title={PAGE.title.support_program} target="sutea" />
    <AssessmentPage />
  </Layout>
)

export default support_program;
